module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mdigurp5-d5e3ed2b8bb4cd02f4cbf9499eadbab1.jpg";